import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import {
    badRequestError,
    invalidApiDataError,
} from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { validatorHomepageMapper } from "../../mappers/validatorInterface/validatorHomepageMapper"
import { IValidatorDevicesData } from "../../types/validatorInterface/validatorHomepageTypes"
import {
    ASSESSOR_DEM_REPORTING,
    ASSESSOR_GEN_REPORTING,
    ASSESSOR_V2G_REPORTING,
} from "../../urls/private"

interface IValidatorHomepageData {
    data: IValidatorDevicesData | undefined
    error: AppError | null
    isLoading: boolean
}

const REPORTING_URL_BY_USER_TYPE: Record<string, string> = {
    V2G: ASSESSOR_V2G_REPORTING,
    GEN: ASSESSOR_GEN_REPORTING,
}

/**
 * Hook to get the validator homepage data
 * @returns The validator homepage data
 */
const useGetValidatorHomepageData = (
    userType: string
): IValidatorHomepageData => {
    const url = REPORTING_URL_BY_USER_TYPE[userType] ?? ASSESSOR_DEM_REPORTING
    const { data, error, isLoading } = useSWR(
        url,
        async (fetchUrl: string): Promise<IValidatorDevicesData> => {
            try {
                const res = await getClientProtected(fetchUrl)
                return validatorHomepageMapper.mapValidatorDevicesData(res)
            } catch (err) {
                badRequestError("Failed to load KPI's")
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return {
        data,
        error,
        isLoading,
    }
}

export { useGetValidatorHomepageData }
